import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Space, Table, notification } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { Container } from "components/Container";
import DocumentoSolicitableService from "services/DocumentoSolicitableService";

const ListarDocumentosSolicitablesPage = () => {
  const history = useHistory();
  const [documentos, setDocumentos] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargarDocumentos = async () => {
    try {
      setLoading(true);
      setDocumentos(await DocumentoSolicitableService.listar());
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarDocumentos();
  }, []);

  const onClickEliminar = async (id) => {
    try {
      await DocumentoSolicitableService.eliminar(id);
      notification.success({
        message: "Operación exitosa",
        description: "Se eliminó el documento. Los colaboradores ya no podrán solicitarlo.",
      });
      cargarDocumentos();
    } catch (error) {
      console.error(error);
    }
  };

  const columnas = [
    { title: "Documento", dataIndex: "nombre" },
    { title: "Descripción", dataIndex: "descripcion" },
    { title: "Plantilla Word", dataIndex: "nombreArchivoPlantilla" },
    {
      title: "Acciones",
      key: "acciones",
      align: "center",
      render: (fila) => (
        <Space>
          <a
            className="custom-color-element"
            onClick={() => history.push(`/configuracion/documentos-solicitables/${fila.id}/editar`)}
          >
            <EditOutlined /> Editar
          </a>
          <Popconfirm
            title="¿Está seguro de eliminar el documento? Los colaboradores ya no podrán solicitarlo."
            okText="Si"
            cancelText="No"
            icon={<QuestionCircleOutlined style={{ color: "red" }} />}
            onConfirm={() => onClickEliminar(fila.id)}
          >
            <a style={{ color: "#CE3E3E" }}>
              <DeleteOutlined /> Eliminar
            </a>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Container
      titulo="Documentos Solicitables"
      botonExtra={
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => history.push("/configuracion/documentos-solicitables/crear")}
        >
          Crear documento
        </Button>
      }
    >
      <Table rowKey="id" columns={columnas} dataSource={documentos} loading={loading} pagination={{ pageSize: 10 }} />
    </Container>
  );
};

export default ListarDocumentosSolicitablesPage;
export { ListarDocumentosSolicitablesPage };
